import React from "react";

export const AssignedBadge = ({ name, phone }) => {
  return (
    <div className="flex items-center w-full h-full py-2">
      <div className="flex items-center gap-2">
        <div className="w-8 h-8 rounded-full bg-gradient-to-br from-blue-500 to-blue-600 flex items-center justify-center text-white font-semibold text-sm">
          {name?.charAt(0)?.toUpperCase() || "?"}
        </div>
        <div className="flex flex-col">
          <span className="font-semibold text-sm text-gray-900">{name}</span>
          <span className="text-xs text-gray-500">{phone}</span>
        </div>
      </div>
    </div>
  );
};

const CellField = ({ value }) => {
  return (
    <div className="flex items-center h-full py-2">
      <span className="font-medium text-sm text-gray-800">{value}</span>
    </div>
  );
};

export default CellField;
